import { createTheme, createVariant, globalTheme } from '@clds/component-theme';
export const tooltipTheme = createTheme({
    paper: {
        background: globalTheme.palette.overlayDark2,
        color: globalTheme.palette.overlayLight,
        border: { radius: globalTheme.radius.md },
        padding: globalTheme.spacing.xs,
        byMaxWidth: {
            sm: { maxWidth: '100px' },
            md: { maxWidth: '200px' },
            lg: { maxWidth: '300px' },
            xl: { maxWidth: '500px' },
            none: { maxWidth: 'none' },
        },
        byFontSize: {
            sm: { fontSize: globalTheme.font.size.xxs },
            md: { fontSize: globalTheme.font.size.xs },
            lg: { fontSize: globalTheme.font.size.sm },
            xl: { fontSize: globalTheme.font.size.md },
        },
        transition: {
            duration: '200ms',
        },
    },
}, 'tooltip');
export const maxWidthVariant = createVariant((props) => tooltipTheme.paper.byMaxWidth[props.maxWidth ?? 'none']);
export const fontSizeVariant = createVariant((props) => tooltipTheme.paper.byFontSize[props.maxWidth ?? 'sm']);
//# sourceMappingURL=theme.js.map